{#await promise}
  <Grid>
		<Row padding>
			<Column xlg={1}><strong style="padding-right: 5px;">Position:</strong><SkeletonText/></Column>
			<Column></Column>
			<Column><strong style="padding-right: 5px;">LitVar Cited:</strong><SkeletonText/></Column>
		</Row>
		<Row padding>
			<Column xlg={1}><strong style="padding-right: 5px;">Alleles:</strong><SkeletonText/></Column>
			<Column></Column>
			<Column><strong style="padding-right: 5px;">Diseases (Top 5):</strong>
				<StructuredListSkeleton rows={3} />
			</Column>
		</Row>
	</Grid>
{:then data}
  <Grid>
	{#if (data)}
		<Row padding>
			<Column xlg={1}><strong style="padding-right: 5px;">Position:</strong>Chr{data.LitVar.data.chromosome_base_position}</Column>
			<Column></Column>
			<Column><strong style="padding-right: 5px;">LitVar Cited:</strong>{data.LitVar.cited}</Column>
		</Row>
		<Row padding>
			<Column xlg={1}><strong style="padding-right: 5px;">Alleles:</strong>{data.dbSNP.alleles}</Column>
			<Column></Column>
			<Column><strong style="padding-right: 5px;">LitVar Diseases (Top 5):</strong>
				<StructList style="margin-bottom: 1rem;">
					<StructHead>
						<StructRow head>
							<StructCell head style="padding: .5rem .5rem .75rem .5rem;">Name</StructCell>
							<StructCell head style="padding: .5rem .5rem .75rem .5rem;">PMID's</StructCell>
						</StructRow>
					</StructHead>
					<StructBody>
						{#each data.LitVar.diseases as dis}
							<StructRow>
								<StructCell nowrap style="padding: .5rem .5rem .75rem .5rem;">{dis.name}</StructCell>
								<StructCell nowrap style="padding: .5rem .5rem .75rem .5rem;">{dis.count}</StructCell>
							</StructRow>
						{:else}
							<StructRow>
								<StructCell nowrap>None</StructCell>
								<StructCell nowrap>0</StructCell>
							</StructRow>
						{/each}
					</StructBody>
				</StructList>
			</Column>
		</Row>
	{:else}
		<Row>
			<Column></Column>
			<Column></Column>
			<Column></Column>
			<Column></Column>
			<Column></Column>
		</Row>
		<Row>
			<Column></Column>
			<Column></Column>
			<Column>NO DATA TO DISPLAY</Column>
			<Column></Column>
			<Column></Column>
		</Row>
		<Row>
			<Column></Column>
			<Column></Column>
			<Column></Column>
			<Column></Column>
			<Column></Column>
		</Row>

	{/if}
	</Grid>

{/await}

<!-- <style lang="scss" global>
	/** Gray 10 theme **/
  @import "carbon-components-svelte/css/g90";
</style> -->

<script>
	export let markerId

	import { navigate } from 'svelte-routing'
	
	import { Firestore } from '../../config/firebase'
  
  import { 
		Grid,
		Row,
		Column,
		SkeletonText,
		StructuredList as StructList,
    StructuredListHead as StructHead,
    StructuredListRow as StructRow,
    StructuredListCell as StructCell,
		StructuredListBody as StructBody,
		StructuredListSkeleton,
	} from "carbon-components-svelte"

	let promise = getMarker()

	async function getMarker() {
		
		let marker = null
		
		try { 
			let doc = await Firestore.collection("markers").doc(markerId).get()
			if (doc.exists) {
				marker = await doc.data()
			}

		} catch (error) {
			console.log("Error getting documents: ", error.message)
		}
		return marker
		
	}
</script>